import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getSourceQueryKey } from "../domain_data";
import { useSourceUrlDetails } from "../utils";
import {
  SOURCES_ROUTE,
  TAGS_ROUTE,
  INTERESTING_THINGS_ROUTE,
  DEBUG_PAGE_ROUTE,
  LOGIN_ROUTE,
} from "../routes";

//TODO: this could be better
function useSetPageTitle() {
  const queryClient = useQueryClient();
  const { sourceId, pageNb } = useSourceUrlDetails();
  const [currentSourceName, setCurrentSourceName] = useState<
    string | undefined
  >(undefined);

  useEffect(() => {
    if (sourceId === undefined) {
      setCurrentSourceName(undefined);
      return;
    }
    const queryKey = getSourceQueryKey(sourceId, pageNb);
    queryClient
      .ensureQueryData(queryKey)
      .then((data: any) => {
        setCurrentSourceName(data.name);
      })
      .catch(() => {
        console.error("error here!");
      });
  }, [sourceId, pageNb]);

  const location = useLocation();
  useEffect(() => {
    let title = "Platz";
    if (location.pathname === SOURCES_ROUTE) {
      title = "Sources";
    } else if (location.pathname.startsWith(SOURCES_ROUTE)) {
      if (currentSourceName) {
        title = currentSourceName;
      }
    } else if (location.pathname === TAGS_ROUTE) {
      title = "Tags";
    } else if (location.pathname === INTERESTING_THINGS_ROUTE) {
      title = "Interesting Words";
    } else if (location.pathname === LOGIN_ROUTE) {
      title = "Log In";
    } else if (location.pathname === DEBUG_PAGE_ROUTE) {
      title = "Debug";
    }
    document.title = title;
  }, [location, sourceId, pageNb, currentSourceName]);
}

export default useSetPageTitle;
